import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_scan",
  "use": "icon-icon_scan-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-icon_scan\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h14v14H0z\" /><path d=\"M12.25 9.625v2.625h-3.5v-1.313h2.1V9.626h1.4Zm-9.1 0v1.313h2.1v1.312h-3.5V9.625h1.4Zm9.1-3.5v1.75H1.75v-1.75h10.5Zm0-4.375v2.625h-1.4V3.062h-2.1V1.75h3.5Zm-7 0v1.313h-2.1v1.312h-1.4V1.75h3.5Z\" fill=\"#3D7BD8\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol